function Convert_Fractional_Input(raw){
    let processed
    if( /([0-9]{1,3}\s+[0-9]{1,2}[\/\-]{1,}[0-9]{1,2})/.test(raw)){
        /* */
        let split_number = raw.split(/\s+/);
        let fraction = split_number[1].split(/[\/\-]{1,}/);
        processed = Number(split_number[0])+Number(fraction[0])/Number(fraction[1]);

    }else if (/([0-9]{1,3}[.,]{1,}[0-9]{1,3})/.test(raw)){
        /* */
        let decimal = raw.split(/[.,]{1,}/);
        processed = Number(decimal[0])+Number(decimal[1])/(10**decimal[1].length);

    } else if(/([0-9]{1,3})/.test(raw)){
        /* */
        processed = Number(raw);
    }
    return processed;
    
    
}